
// Centralize notification frequency constants and utility functions
export const NOTIFICATION_FREQUENCIES = {
  IMMEDIATE: 'immediate',
  DAILY: 'daily',
  WEEKLY: 'weekly',
  NEVER: 'never'
} as const;

export type NotificationFrequency = typeof NOTIFICATION_FREQUENCIES[keyof typeof NOTIFICATION_FREQUENCIES];

export const isFrequencyAllowedForType = (
  frequency: NotificationFrequency, 
  notificationType: string
): boolean => {
  // Add custom logic for specific notification types if needed
  return true;
};

/**
 * Determines whether a notification should be sent based on frequency settings
 * and the time of the last notification (if applicable)
 */
export const shouldSendNotification = (
  frequency: NotificationFrequency,
  lastNotificationTime?: Date
): boolean => {
  if (frequency === NOTIFICATION_FREQUENCIES.NEVER) return false;
  if (frequency === NOTIFICATION_FREQUENCIES.IMMEDIATE) return true;
  
  if (!lastNotificationTime) return true; // No previous notification, so send
  
  const now = new Date();
  const timeDiff = now.getTime() - lastNotificationTime.getTime();
  const hoursDiff = timeDiff / (1000 * 3600);
  
  if (frequency === NOTIFICATION_FREQUENCIES.DAILY) {
    return hoursDiff >= 24;
  }
  
  if (frequency === NOTIFICATION_FREQUENCIES.WEEKLY) {
    return hoursDiff >= 24 * 7; // 168 hours
  }
  
  return true; // Default to sending if the frequency is not recognized
};
